import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTrackingPages = {
  name: "getTrackingPages" as const,
  input: z.object({}),
  output: z.array(
    z.object({ _id: zExt.objectId(), name: z.string().nullable() }),
  ),
};
